import { render, staticRenderFns } from "./ImageGroup.vue?vue&type=template&id=ba8752e0&scoped=true&"
import script from "./ImageGroup.vue?vue&type=script&lang=ts&"
export * from "./ImageGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ImageGroup.vue?vue&type=style&index=0&id=ba8752e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8752e0",
  null
  
)

export default component.exports